import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { IUser } from '../models/IUser';
import { IPasswordValidations } from '../models/IPasswordValidations';
import { ILoginCredentials } from '../models/ILoginCredentials';

@Injectable()
export class AuthService {

  redirectUrl: string;
  private baseUrl = environment.baseUrl;

  constructor(private http: HttpClient) { }

  login(credentials: ILoginCredentials): Observable<{token: string, user: IUser}> {
    return this.http.post<{token: string, user: IUser}>(`${this.baseUrl}/login`, credentials);
  }

  // TODO return type
  logout() {
    console.log('CLEARING LOCAL STORAGE - 3');
    localStorage.clear(); // TODO: Already Checked
    window.open(environment.my_journey_url + environment.logoutEndPoint, '_self');
  }

  // TODO return type
  requestReset(email: string): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/forgotpassword`, email);
  }

  // TODO return type
  acceptTerms(): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/auth/accepttc`, {});
  }

  validateResetToken(url: any): Observable<{id: number, failure: boolean}> {
    return this.http.post<{id: number, failure: boolean}>(`${this.baseUrl}/forgotpasswordexpiry`, url);
  }

  sendReset(password: string, userId: number): Observable<boolean> {
    return this.http.put<boolean>(`${this.baseUrl}/resetpassword`, {password, userId});
  }

  validatePassword(password: string): Observable<IPasswordValidations> {
    return this.http.post<IPasswordValidations>(`${this.baseUrl}/validatepassword`, {password});
  }

}
